import * as React from 'react';

import type { IconProps } from './types';

export const Paragraph = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_300_232)">
        <path
          d="M5.99902 0.259396C5.739 0.168762 5.49756 0.150635 5.21896 0.150635C4.95894 0.150635 4.68035 0.168762 4.42033 0.259396L0 11.77C0.278592 11.915 0.557185 11.9694 0.891496 11.9694C1.0958 11.9694 1.31867 11.9512 1.56012 11.8969L2.74878 8.65215H7.67058L8.89638 11.8969C9.11926 11.9512 9.41642 11.9694 9.62072 11.9694C9.99218 11.9694 10.2522 11.915 10.5122 11.77L5.99902 0.259396ZM3.2131 7.38326L4.84751 2.88779L5.16325 1.90894L5.47898 2.88779L7.18768 7.38326H3.2131Z"
          fill={color}
        />
        <path
          d="M14.2146 3.10522C12.7287 3.10522 11.4472 3.72154 10.89 4.26535C10.9643 4.66414 11.2243 5.0448 11.6515 5.2442C12.1901 4.84541 13.0816 4.46474 14.1403 4.46474C15.6818 4.46474 16.5362 5.15356 16.5362 6.44057V7.09314C15.9047 6.83936 15.0689 6.65809 14.1031 6.65809C12.0601 6.65809 10.5 7.63695 10.5 9.37713C10.5 10.9542 11.5958 12.1505 14.2703 12.1505C15.6447 12.1505 17.1862 11.7518 18.0034 11.3167V6.44057C18.0034 4.04782 16.3133 3.10522 14.2146 3.10522ZM12.0415 9.30462C12.0415 8.32577 12.8959 7.9451 14.1031 7.9451C14.9946 7.9451 15.8304 8.09012 16.5362 8.4164V10.501C15.9604 10.7004 15.1804 10.8454 14.2889 10.8454C12.7845 10.8454 12.0415 10.2291 12.0415 9.30462Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_300_232">
          <rect width="18" height="12" fill="white" transform="translate(0 0.150635)" />
        </clipPath>
      </defs>
    </svg>
  )
);

export default Paragraph;
